module.exports = new __parcel__URL__("menu-share.1a35d2fe.svg").toString();